
<div>
  <button
    class="rfp-ratings-carousel-prev-next-button rfp-ratings-carousel-previous"
    :style="`padding: ${clickTargetSize}px; margin-right: -${clickTargetSize}px;`"
    @click="$emit('navigate-prev')"
  >
    &larr;
  </button>
  <button
    class="rfp-ratings-carousel-prev-next-button rfp-ratings-carousel-next"
    :style="`padding: ${clickTargetSize}px; margin-left: -${clickTargetSize}px;`"
    @click="$emit('navigate-next')"
  >
    &rarr;
  </button>
</div>
